import { useEffect, useRef } from 'react'

export function useMountedRef() {
  const mounted = useRef(false)

  // lifecycle integration
  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])

  return mounted
}

export function usePrevious<T>(value: T) {
  const ref = useRef<T>(value)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
